<script lang="ts">

    import { onDestroy, onMount } from 'svelte';
    import { ToastProperties, storeNotification, emptyNotification } from "../scripts/toaster";
    import Toast from "./Toast.svelte";

    let itemsTopRight: ToastProperties[] = [];

    onMount(async () => {
        const unsubscribe = storeNotification.subscribe((notification) => {
            if (notification != emptyNotification) {
                const notificationPropertie: ToastProperties = {
                    message: notification.message,
                    level: notification.level
                }
            addToastTopRight(notificationPropertie);
            }
        });
	});

    onDestroy(() => {
        storeNotification.set(emptyNotification);
    });

    function addToastTopRight(toastProperties: ToastProperties) {
        itemsTopRight.push(toastProperties);
        itemsTopRight = itemsTopRight;
    }


</script>

<style lang="scss">

    .toaster {
        margin: 0px 40px 0px 40px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        &__buttons {
            display: flex;
            flex-direction: row;
            &__button {
                margin: 0px 12px 0 12px;
                border: 1px solid lightgrey;
                padding: 4px 4px 4px 4px;
                button {
                    cursor: pointer;
                }
            }
        }
    }

    .toastsTopRight {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-end;
        position: fixed;
        z-index: 10000;
        right: 0;
        top: 140px;
    }

</style>

<div class="toaster">
    <div class="toastsTopRight">
        {#each itemsTopRight as item}
            <Toast props={item} />
        {/each}
    </div>    
</div>
